import { createClient } from '@zg-rentals/http-client';
import { makeModuleInstance } from '@zg-rentals/util';

// Default, supports Webpack-based apps. Next.js apps must configure client with
// prefixUrl explicitly
const prefixUrl = typeof __API__ !== 'undefined' ? __API__ : undefined;

// Allow apps to override base http client if they desire
export const { get: getClient, set: setClient } = makeModuleInstance(
  createClient({ prefixUrl, credentials: 'include' }),
);

export { createClient };
